import React from 'react';

// Metres, rounded the way a person reads them: no decimal past 10 m, one below
// (a check-in 3.4 m out is a different story from one 34 m out).
const formatMetres = (m) => (m >= 10 ? `${Math.round(m)} m` : `${Math.round(m * 10) / 10} m`);

// The GPS verdict of a QR check-in, three-valued — and the
// third value is the COMMON one: every row filed by hand, by batch, by an
// approved dispute or by the completion booking has no reading, and so does a
// scan with location denied. It renders as a quiet dash, not a warning.
//
// One component for every surface that shows the verdict (management
// Attendance tab, dashboard Attendance tab, session detail panel, live QR
// list), so "outside" looks the same everywhere: amber, per the house rule —
// it flags an exception to follow up, not an offence (same as the chart-status
// convention).
//
// The badge prints the VERDICT ONLY: a column of "At venue ·
// 57 m" reads as noise when the number only matters for the one row someone
// is arguing about. The distance is still carried — in `title` on hover, and
// in full where `onClick` is given (management Attendance tab, dashboard
// Participation Records) as a button opening the evidence panel, which also
// fetches the raw coordinates one row at a time.
const VenueCheckBadge = ({ value, distanceM = null, radiusM = null, onClick = null }) => {
  if (value !== true && value !== false) {
    return (
      <span
        className="text-xs text-slate-400"
        title="No location reading — not a QR scan, location was off, or the session has no venue coordinates."
      >
        —
      </span>
    );
  }

  const inRange = value === true;
  const styles = inRange
    ? 'bg-green-50 text-green-700 hover:bg-green-100'
    : 'bg-amber-50 text-amber-800 hover:bg-amber-100';
  const distance = distanceM == null ? null : formatMetres(distanceM);

  const title = distance
    ? `${distance} from the venue${radiusM != null ? ` (allowed ${formatMetres(radiusM)})` : ''}`
      + (onClick ? ' — click for the coordinates' : '')
    : (onClick ? 'Click for the coordinates' : undefined);

  const content = inRange ? 'At venue' : 'Outside venue';
  const base = 'inline-flex items-center px-1.5 py-0.5 text-xs font-medium rounded whitespace-nowrap';

  if (!onClick) {
    return <span className={`${base} ${styles}`} title={title}>{content}</span>;
  }
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={`${base} ${styles} cursor-pointer transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 ${inRange ? 'focus:ring-green-400' : 'focus:ring-amber-400'}`}
    >
      {content}
    </button>
  );
};

export default VenueCheckBadge;
